import { API_BASE } from "../../config/env";
import axios from "axios";
export const FETCH_VERIFYCODE_FULFILLED = "FETCH_VERIFYCODE_FULFILLED";
export const FETCH_VERIFYCODE_REJECTED = "FETCH_VERIFYCODE_REJECTED";
export const FETCH_VERIFYCODE_PENDING = "FETCH_VERIFYCODE_PENDING";

function uuidv4() {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
        (
            c ^
            (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
        ).toString(16)
    );
}

export function verifyCode(code) {
    localStorage.setItem("One-Id", uuidv4())
    localStorage.setItem("Client-Id", uuidv4())
    const phoneNumber = localStorage.getItem("phoneNumber")
    return (dispatch) => {
    dispatch({
      type: "FETCH_VERIFYCODE",
      payload: axios({
        method: "post",
        url: `${API_BASE}/api/v2/auth/verify-code`,
        data: { phoneNumber, code },
        headers: {
          "Accept-Language": "tr-tr",
          "Client-Id": localStorage.getItem("One-Id"),
          "One-Id": localStorage.getItem("Client-Id"),
          "Content-Type": "application/json",
          "ngrok-skip-browser-warning" : "69920"
        },
      }).then((result) => result.data),
    });
  };
}



